import dao from '../../../dao/configDao';

const QUERY_CREDENTIAL = 'pages/webmodule/apidocument/QUERY_CREDENTIAL';
const QUERY_CREDENTIAL_SUCCESS =
  'pages/webmodule/apidocument/QUERY_CREDENTIAL_SUCCESS';

const initialState = {
  credential: {},
  isLoaded: false,
};
export default (state = initialState, action = {}) => {
  switch (action.type) {
    case QUERY_CREDENTIAL:
      return {
        ...state,
        isLoaded: false,
      };
    case QUERY_CREDENTIAL_SUCCESS:
      return {
        ...state,
        isLoaded: true,
        credential: action.json,
      };
    default:
      return state;
  }
};

export function queryCredential() {
  return dispatch => {
    dispatch({
      type: QUERY_CREDENTIAL,
    });
    return dao
      .queryCredential()
      .then(json => dispatch(queryCredentialSuccess(json)));
  };
}

function queryCredentialSuccess(json) {
  return {
    type: QUERY_CREDENTIAL_SUCCESS,
    json,
  };
}
